"use client";

import { Bookmark, Gauge, LayoutTemplate, Sparkles, Target } from "lucide-react";
import { RESUME_TEMPLATES } from "@/utils/resumeTemplates";

const FEATURES = [
  {
    icon: Target,
    title: "Tailored, never invented",
    text: "Your summary, bullets and skills are rewritten around the job's keywords, using only what's in your resume.",
  },
  {
    icon: Gauge,
    title: "Live job match score",
    text: "See how well you fit the job and raise your score with one-click suggestions.",
  },
  {
    icon: Sparkles,
    title: "Regenerate any section",
    text: "Rewrite a section or a single role with your own prompt. Undo anytime.",
  },
  {
    icon: Bookmark,
    title: "Save your resume once",
    text: "Keep resume profiles and reuse them for every job, without uploading again.",
  },
  {
    icon: LayoutTemplate,
    title: `${RESUME_TEMPLATES.length} ATS-friendly templates`,
    text: "Clean, single-column designs that applicant tracking systems read correctly.",
  },
];

export default function Features() {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          Built to get you shortlisted
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {FEATURES.map(({ icon: Icon, title, text }) => (
            <div key={title} className="text-center sm:text-left">
              <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-r from-blue-600 to-purple-600">
                <Icon className="h-5 w-5 text-white" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
